export default __webpack_public_path__ + "static/media/partner-call.2ea56b94.wav";